<div
  class="container main-navigation p-3"
  [attr.id]="'header-navigation-panel-' + type"
  [class.hide]="!_visible"
>
  <div class="navigation--container">
    <div>
      <ng-container
        *ngTemplateOutlet="
          type === onDemandType ? featureProductsView : featureProgramsView
        "
      ></ng-container>
    </div>
    <div>
      <h3 class="mb-3">Programs</h3>
      <div class="navigation__programs default-scroll">
        @if (!isProgramsLoading) {
          @for (program of programs; track program) {
            <div>
              <a
                href="#"
                [attr.id]="'nav-program-' + program.id"
                class="d-inline-block full-width mb-3 link color-black fw-normal text-transformation-none font-4"
                (click)="navigateToProgram(program)"
              >
                <span
                  class="d-block text-hidden-ellipsis"
                  [innerHTML]="program.label | safeContent"
                ></span>
              </a>
            </div>
          }
        } @else {
          <div class="loader-inner mt-30px">
            <div class="loader"></div>
          </div>
        }
      </div>
      <button
        id="nav-all-programs-btn"
        class="btn btn-outline-primary d-block mx-auto mt-3"
        (click)="navigateToProgram()"
      >
        All Programs
      </button>
    </div>
    <div>
      <h3 class="mb-3">Brands</h3>
      <div class="navigation__brands default-scroll">
        @if (!isBrandsLoading) {
          @for (brand of filteredBrands; track $index) {
            <div>
              <a
                href="#"
                class="d-inline-block full-width mb-3 link color-black fw-normal text-transformation-none font-4"
                (click)="navigateToFilteredProducts('BRAND', brand)"
              >
                <span
                  class="d-block text-hidden-ellipsis"
                  [innerHTML]="brand | safeContent"
                ></span>
              </a>
            </div>
          }
        } @else {
          <div class="loader-inner mt-30px">
            <div class="loader"></div>
          </div>
        }
      </div>
      <div class="mt-3">
        <div class="mx-auto w-90pct mw-210px">
          <input
            id="nav-search-brands-input"
            type="text"
            class="form-control"
            [(ngModel)]="searchBrand"
            placeholder="Type to Search Brands"
            (input)="findBrands()"
            [disabled]="!brands.length"
          />
        </div>
      </div>
    </div>
    <div>
      <h3 class="mb-3">Categories</h3>
      <div class="navigation__categories default-scroll">
        @if (!isCategoriesLoading) {
          @for (category of categories; track $index) {
            <div>
              <a
                href="#"
                class="d-inline-block full-width mb-3 link color-black fw-normal text-transformation-none font-4"
                (click)="navigateToFilteredProducts('CATEGORY', category)"
              >
                <span
                  class="d-block text-hidden-ellipsis"
                  [innerHTML]="category | safeContent"
                ></span>
              </a>
            </div>
          }
        } @else {
          <div class="loader-inner mt-30px">
            <div class="loader"></div>
          </div>
        }
      </div>
    </div>
  </div>
  <div class="navigation--footer mt-3">
    @if (type === onDemandType) {
      <div class="navigation--footer__label fw-bold uppercase">
        <span>On Demand</span>
      </div>
    } @else {
      <div class="navigation--footer__bw-label fw-bold uppercase">
        @if (!isHomePage) {
          <a href="#" id="nav-change-window-link" (click)="navigateToHomePage()"
            ><i class="far fa-backward"></i> Change Window</a
          >
        }
        <span>{{ buyingWindowLabel }}</span>
        <button
          id="nav-bw-all-products-btn"
          class="btn btn-outline-primary"
          (click)="navigateToProduct()"
        >
          All Products
        </button>
      </div>
    }

    <div class="navigation--footer__quick-order">
      <span>Need to place an order quickly?</span>
      <button
        id="nav-quick-order-btn"
        class="btn btn-outline-primary"
        (click)="navigationToQuickOrder()"
        [disabled]="!availableQuickOrder"
      >
        Quick Order
      </button>
    </div>
  </div>
</div>

<ng-template #featureProductsView>
  <h3 class="mb-3">Featured Products</h3>
  <div class="navigation__products default-scroll">
    @if (!isProductsLoading) {
      @for (product of featureProducts; track product) {
        <div
          [attr.id]="'nav-featured-product-' + product.firstSkuId"
          class="product-item d-flex mb-3"
          role="link"
          (click)="navigateToProduct(product)"
        >
          <img
            class="product-image"
            [src]="product.media | thumbnail"
            alt="Product Image"
          />
          <div class="ms-3">
            <h4
              [innerHTML]="product.label | safeContent"
              class="word-break-word"
            ></h4>
            <span class="font-5">SKU: {{ product.firstSkuId }}</span>
          </div>
        </div>
      }
    } @else {
      <div class="loader-inner mt-30px">
        <div class="loader"></div>
      </div>
    }
  </div>
  <button
    id="nav-od-all-products-btn"
    class="btn btn-outline-primary d-block mx-auto mt-3"
    (click)="navigateToProduct()"
  >
    All Products
  </button>
</ng-template>

<ng-template #featureProgramsView>
  <h3 class="mb-3">Featured Programs</h3>
  <div class="navigation__feature_programs default-scroll">
    @if (!isProgramsLoading) {
      @for (program of featurePrograms; track program) {
        <div
          [attr.id]="'nav-featured-program-' + program.id"
          class="product-item d-flex mb-3 align-items-center"
          role="link"
          (click)="navigateToProgram(program)"
        >
          <img
            class="program-image"
            [src]="program.media | thumbnail"
            alt="Product Image"
          />
          <div class="ms-3">
            <h4
              [innerHTML]="program.label | safeContent"
              class="m-0 word-break-word"
            ></h4>
          </div>
        </div>
      }
    } @else {
      <div class="loader-inner mt-30px">
        <div class="loader"></div>
      </div>
    }
  </div>
</ng-template>
